import React from "react";
import MegaMenu from "@insightfulscience/atomic-react/MegaMenu";
import MegaMenuTitle from "@insightfulscience/atomic-react/MegaMenu/Title";
import MegaMenuItem from "@insightfulscience/atomic-react/MegaMenu/Item";
import { MegaMenuCol } from "@insightfulscience/atomic-react/MegaMenu/Grid";
import { useLocale } from "@insightfulscience/i18";
import routes from "@src/routes";

const ResourcesDropdown = () => {
	const [t] = useLocale("common");

	return (
		<MegaMenu>
			<MegaMenuCol lg={2} md={12} spacing={{ lg: { ml: 59 } }}>
				<MegaMenuTitle uppercase>{t("MENU.RESOURCES")}</MegaMenuTitle>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.resources.url}
						className="nav__item-link"
					>
						{t("MENU.RESOURCE_CENTER")}
					</MegaMenuItem.Link>
				</MegaMenuItem>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.resources.subRoutes.gettingStarted.url}
						className="nav__item-link"
					>
						{t("MENU.GETTING_STARTED")}
					</MegaMenuItem.Link>
				</MegaMenuItem>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.guides.subRoutes.tutorial.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.resources.OMIQ_TUTORIAL")}
					</MegaMenuItem.Link>
				</MegaMenuItem>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.resources.subRoutes.userGuides.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.resources.USER_GUIDES")}
					</MegaMenuItem.Link>
				</MegaMenuItem>
			</MegaMenuCol>
		</MegaMenu>
	);
};

export default ResourcesDropdown;
